import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css/animate.min.css";
import Router from './router/NavRouter';
import SEO from "./helper/SEO";
import { ToastContainer } from 'react-toastify';
import { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { BaseUrl } from './helper/BaseUrl';
import { HelmetProvider } from 'react-helmet-async';
import { ModalProvider } from './contexts/ModalContext';

function App({ initialData, initialSeo, initialSchema, helmetContext }) {
  const [seoData, setSeoData] = useState(initialSeo || null);
  const [schemaData, setSchemaData] = useState(initialSchema || null);
  const location = useLocation();

  useEffect(() => {
    const controller = new AbortController();

    const Detailfetcher = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/seo${location.pathname}`, {
          method: 'GET',
          signal: controller.signal,
        });

        if (!response.ok) {
          setSeoData(null);
          return;
        }

        const result = await response.json();
        if (result.data === false) {
          setSeoData(null);
          return;
        }

        setSeoData(Array.isArray(result.data) ? null : result.data);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Fetch error:', error.message);
        }
      }
    };

    setSeoData(null);
    Detailfetcher();

    return () => controller.abort();
  }, [location.pathname])


  useEffect(() => {
    if (schemaData) {
      return;
    }

    const fetchSchema = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/schema`, {
          method: 'GET',
        });
        const result = await response.json();
        setSchemaData(result.data);
      } catch (error) {
        console.error('Schema fetch error:', error.message);
      }
    };

    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      const idleId = window.requestIdleCallback(fetchSchema, { timeout: 5000 });
      return () => window.cancelIdleCallback(idleId);
    }

    const timer = setTimeout(fetchSchema, 3000);
    return () => clearTimeout(timer);
  }, [schemaData]);


  useEffect(() => {
    if (!sessionStorage.getItem("first_landing_url")) {
      sessionStorage.setItem("first_landing_url", window.location.href);
    }
  }, []);


  const NormalizeTrailingSlash = () => {
    useEffect(() => {
      if (location.pathname !== '/' && location.pathname.endsWith('/')) {
        window.history.replaceState(
          null,
          '',
          location.pathname.slice(0, -1) + location.search + location.hash
        );
      }
    }, []);

    return null;
  };

  return (
    <HelmetProvider context={helmetContext}>
      <div className="App">
        <NormalizeTrailingSlash />
        <SEO seoData={seoData} schemaData={schemaData}/>
        <ModalProvider>
          <Router initialData={initialData} />
        </ModalProvider>
        <ToastContainer />
      </div>
    </HelmetProvider>
  );
}

export default App;
